import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import categoriesData from "../../../../jsonData/categoryData.json";
import AdmissionTest from "../../../../jsonData/AdmissionTest.json";
import BanglaVersion from "../../../../jsonData/BanglaVersion.json";
import EnglishVersion from "../../../../jsonData/EnglishVersion.json";
import EnglishMedium from "../../../../jsonData/EnglishMedium.json";
import MadrasaMedium from "../../../../jsonData/MadrasaMedium.json";
import ReligiousStudies from "../../../../jsonData/ReligiousStudies.json";
import Arts from "../../../../jsonData/arts.json";
import TestPreparation from "../../../../jsonData/TestPreparation.json";
import { Link } from "react-router-dom";
import GreenSpinner from "../../../Shared/Loading/GreenSpinner";
import toast from "react-hot-toast";

// Map categories to subjects
const categorySubjects = {
  BanglaVersion: BanglaVersion,
  EnglishVersion: EnglishVersion,
  EnglishMedium: EnglishMedium,
  MadrasaMedium: MadrasaMedium,
  ReligiousStudies: ReligiousStudies,
  AdmissionTest: AdmissionTest,
  TestPreparation: TestPreparation,
  Arts: Arts,
};

const dateFormat = (dateString) => {
  // Array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Create a new Date object
  const date = new Date(dateString);

  // Extract the month, day, and year
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Format the date as "Jul 31, 2024"
  return `${month} ${day}, ${year}`;
};

const AllLeadsGreen = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [gender, setGender] = useState("any");
  const [city, setCity] = useState("");
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [jobId, setJobId] = useState(""); // New state to hold the jobId input

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setCategories(categoriesData);
  }, []);

  const [appliedFilters, setAppliedFilters] = useState({
    gender: "any",
    city: "",
    areas: [],
    startDate: "",
    endDate: "",
    subjects: [],
    categories: [],
  });

  useEffect(() => {
    if (selectedCategories.length > 0) {
      const newSubjects = selectedCategories.flatMap(
        (category) => categorySubjects[category] || []
      );
      setSubjects(newSubjects);
    } else {
      setSubjects([]);
      setSelectedSubjects([]);
    }
  }, [selectedCategories]);

  const fetchJobs = useCallback(async () => {
    try {
      const response = await axios.get("https://tutor-tree-server-1.vercel.app/new-jobs-all", {
        params: {
          page,
          limit: 20,
          ...appliedFilters,
          areas: selectedAreas.join(","),
          categories: selectedCategories.join(","),
          subjects: selectedSubjects.join(","),
          jobId,
        },
      });
      setJobs(response.data.jobs);
      setTotalPages(response.data.pages);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [
    page,
    appliedFilters,
    jobId,
    selectedAreas,
    selectedCategories,
    selectedSubjects,
  ]);

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  const handlePreviousPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNextPage = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleSearch = () => {
    setAppliedFilters({
      gender,
      city,
      areas: selectedAreas,
      startDate,
      endDate,
      categories: selectedCategories,
      subjects: selectedSubjects,
    });
    setPage(1); // Reset to the first page
  };

  const clearFilters = () => {
    setGender("any");
    setCity("");
    setSelectedAreas([]);
    setStartDate("");
    setEndDate("");
    setSelectedCategories([]);
    setSelectedSubjects([]);
    setAppliedFilters({
      gender: "any",
      city: "",
      areas: [],
      startDate: "",
      endDate: "",
      subjects: [],
      categories: [],
    });
    setPage(1); // Reset to the first page
  };

  const handleJobIdChange = (e) => {
    setJobId(e.target.value);
  };
  /////////// HANDLE PUBLISH ///////
  //////////////////////////////////

  const handleMakePublish = (id) => {
    console.log(id);

    fetch(`https://tutor-tree-server-1.vercel.app/allTutors/publish/${id}`, {
      method: "PUT",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Published successful.");
          fetchJobs();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };

  /////////// HANDLE MAKE FOLLOW UP ////////
  ///////////////////////////////////////////

  const handleMakeFollowUp = (id) => {
    fetch(`https://tutor-tree-server-1.vercel.app/allTutors/followUp/${id}`, {
      method: "PUT",
      body: JSON.stringify({}), // IncludTwo in the request body
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Follow up successful.");
          fetchJobs();
          // Re-fetch the updated user data
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };

  ////////// HANDLE CANCELLED MODAL ///////////
  /////////////////////////////////////////////

  const handleMakeCancelled = (id, selectedReason) => {
    if (!selectedReason) {
      toast.error("Please select a reason before submitting.");
      return;
    }

    fetch(`https://tutor-tree-server-1.vercel.app/allTutors/cancelled/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ reason: selectedReason }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Cancelled successful.");
          fetchJobs();
          // Re-fetch the updated user data

          // Call the fetchUsers function again to update the user data
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [selectedReason, setSelectedReason] = useState("");
  const handleButtonClick = (apply) => {
    setSelectedItem(apply);
    setModalOpen(!isModalOpen);
  };

  if (loading) {
    return <GreenSpinner></GreenSpinner>;
  }
  return (
    <div className="">
      <div className="flex rounded-lg dropdown-container sticky top-0 z-40 shadow-md  justify-between items-center py-4 px-6 bg-green-50 w-full">
        <div className="flex flex-row items-center">
          <div className="grid grid-cols-2 gap-2">
            <div className="">
              <label className="block mb-2 text-lg font-montserrat text-green-900">
                Start Date
              </label>
              <input
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
                className="w-full p-2 py-4 rounded-lg !border-2 border-green-300 text-lg font-montserrat text-green-900"
              />
            </div>

            <div className="mb-4">
              <label className="block mb-2 text-lg font-montserrat text-green-900">
                End Date
              </label>
              <input
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
                className="w-full p-2 py-4 rounded-lg !border-2 border-green-300 text-lg font-montserrat text-green-900"
              />
            </div>
          </div>

          <div className="flex flex-row gap-5 ml-5 mt-4">
            <button
              onClick={handleSearch}
              className="text-white px-6 py-4 rounded bg-green-600 duration-300 font-roboto text-xl"
            >
              Search
            </button>
            <button
              onClick={clearFilters}
              className="text-green-900 ml-2 px-6 py-4 rounded bg-green-100 duration-300 font-roboto text-xl"
            >
              Clear
            </button>
          </div>
        </div>
        <div className="flex flex-row">
          <input
            className="border border-green-400 rounded font-montserrat focus:border-green-600"
            type="text"
            value={jobId}
            onChange={handleJobIdChange}
            placeholder="Enter Job ID"
          />
        </div>
      </div>

      <div className="w-full bg-white mt-5">
        <div class=" overflow-x-auto h-[600px]">
          <div class="relative  shadow-md sm:rounded-lg">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead class="text-xs text-white uppercase bg-green-500 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" class="px-6 py-3">
                    #
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Job Id
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Name
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Joining Date
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Status
                  </th>
                  <th scope="col" class="px-6 py-3">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              {jobs.map((job, index) => (
                <tbody>
                  <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {index + 1}
                    </th>
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {job.jobId}
                    </th>
                    <td class="px-6 py-4">
                      {job.name} {job.posterName}
                    </td>
                    <td class="px-6 py-4">{dateFormat(job.joiningDate)}</td>
                    <td class="px-6 py-4">
                      <div className="dropdown w-28">
                        <div tabIndex={0} role="button" className="roleBtn">
                          {job.leads}
                        </div>
                        <ul
                          tabIndex={0}
                          className="dropdown-content z-[1] menu p-2 shadow rounded border border-green-700 bg-white  w-full"
                        >
                          {job?.leads === "publish" ? (
                            <button
                              disabled
                              className="w-full h-8  bg-green-200 mt-2   focus:bg-green-600 rounded-md text-white  flex justify-center items-center"
                            >
                              Published
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                handleMakePublish(job._id);
                              }}
                              className="w-full h-8  bg-green-400 mt-2 hover:bg-green-600 focus:bg-green-600 rounded text-white  flex justify-center items-center"
                            >
                              Published
                            </button>
                          )}
                          {/* {job?.leads === "followUp" ? (
                              <button
                                disabled
                                className="w-full h-8  bg-green-200 mt-2   focus:bg-green-600 rounded text-white  flex justify-center items-center"
                              >
                                Follow Up
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakeFollowUp(job._id); // Cjob the first function
                                  // Cjob the second function
                                }}
                                className="w-full h-8  bg-green-400 mt-2 hover:bg-green-600 focus:bg-green-600 rounded text-white  flex justify-center items-center"
                              >
                                Follow Up
                              </button>
                            )} */}

                          {isModalOpen && selectedItem && (
                            <div className="container max-w-[1000px] mx-auto">
                              <div className="p-10 flex justify-center items-center bg-white w-[380px] h-[300px] border-2 border-gray-200 rounded-lg contentApplicationLeed">
                                <div className="flex flex-col justify-center items-center p-20">
                                  <div className="flex justify-end  w-full">
                                    <button
                                      onClick={() => setModalOpen(false)}
                                      className="w-8 h-8 rounded-full flex justify-center items-center "
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M6 18L18 6M6 6l12 12"
                                        />
                                      </svg>
                                    </button>
                                  </div>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="68"
                                    height="60"
                                    viewBox="0 0 68 60"
                                    fill="none"
                                  >
                                    <path
                                      d="M66.2224 49.7273L39.4837 3.43836C38.888 2.39399 38.0266 1.52582 36.9869 0.921949C35.9472 0.318077 34.7663 0 33.5639 0C32.3616 0 31.1807 0.318077 30.141 0.921949C29.1013 1.52582 28.2399 2.39399 27.6441 3.43836L0.905452 49.7273C0.309118 50.7702 -0.00308973 51.9514 2.30503e-05 53.1528C0.00313583 54.3541 0.321461 55.5336 0.923191 56.5734C1.52492 57.6133 2.38899 58.477 3.42906 59.0782C4.46912 59.6795 5.64877 59.9973 6.85014 59.9999H60.2777C61.4837 60.0049 62.6694 59.6898 63.7138 59.0868C64.7581 58.4838 65.6238 57.6144 66.2224 56.5674C66.8326 55.531 67.1545 54.3501 67.1545 53.1474C67.1545 51.9446 66.8326 50.7638 66.2224 49.7273ZM64.0584 55.3238C63.683 55.9947 63.1338 56.552 62.4685 56.9372C61.8032 57.3223 61.0464 57.5211 60.2777 57.5126H6.85014C6.08622 57.5083 5.33673 57.3042 4.67614 56.9205C4.01556 56.5368 3.46687 55.987 3.08461 55.3256C2.70235 54.6641 2.49983 53.9142 2.49716 53.1503C2.49449 52.3864 2.69178 51.635 3.06942 50.971L29.7832 4.68201C30.1701 4.03816 30.7171 3.50539 31.3708 3.13551C32.0246 2.76564 32.763 2.57125 33.5142 2.57125C34.2653 2.57125 35.0037 2.76564 35.6575 3.13551C36.3113 3.50539 36.8582 4.03816 37.2452 4.68201L64.0584 50.971C64.4479 51.6301 64.6534 52.3818 64.6534 53.1474C64.6534 53.913 64.4479 54.6646 64.0584 55.3238ZM32.3203 38.3603V17.3425C32.3203 17.0126 32.4513 16.6963 32.6845 16.4631C32.9178 16.2298 33.2341 16.0988 33.5639 16.0988C33.8938 16.0988 34.2101 16.2298 34.4433 16.4631C34.6766 16.6963 34.8076 17.0126 34.8076 17.3425V38.3603C34.8076 38.6901 34.6766 39.0065 34.4433 39.2397C34.2101 39.4729 33.8938 39.6039 33.5639 39.6039C33.2341 39.6039 32.9178 39.4729 32.6845 39.2397C32.4513 39.0065 32.3203 38.6901 32.3203 38.3603ZM36.0512 47.5634C36.0512 48.0553 35.9054 48.5362 35.6321 48.9452C35.3587 49.3543 34.9703 49.6731 34.5158 49.8613C34.0613 50.0496 33.5612 50.0989 33.0787 50.0029C32.5962 49.9069 32.153 49.67 31.8051 49.3222C31.4573 48.9743 31.2204 48.5311 31.1244 48.0486C31.0284 47.5661 31.0777 47.066 31.2659 46.6115C31.4542 46.157 31.773 45.7685 32.182 45.4952C32.5911 45.2219 33.072 45.076 33.5639 45.076C34.2236 45.076 34.8563 45.3381 35.3227 45.8046C35.7892 46.271 36.0512 46.9037 36.0512 47.5634Z"
                                      fill="#0E73B7"
                                    />
                                  </svg>
                                  <p className="reasonTittle mr-5">
                                    Reason For Cancellation
                                  </p>

                                  <select
                                    className="select select-primary w-full mt-5"
                                    value={selectedReason}
                                    onChange={(e) =>
                                      setSelectedReason(e.target.value)
                                    }
                                  >
                                    <option value="">Select a reason</option>
                                    <option value="Late Follow Up">
                                      Late Follow Up
                                    </option>
                                    <option value="Already Found Tutor">
                                      Already Found Tutor
                                    </option>
                                    <option value="Unreachable">
                                      Unreachable
                                    </option>
                                    <option value="Submitted By Mistake">
                                      Submitted by Mistake
                                    </option>
                                    <option value="Doesn't Need TutorAnymore">
                                      Doesn't Need Tutor Anymore
                                    </option>
                                    <option value="Unreasonable Requirements">
                                      Unreasonable Requirements
                                    </option>
                                  </select>
                                  <button
                                    onClick={() =>
                                      handleMakeCancelled(
                                        selectedItem._id,
                                        selectedReason
                                      )
                                    }
                                    className="ModalSubmit w-56 mt-5"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}

                          <button
                            onClick={() => {
                              handleButtonClick(job);
                              // Assuming you want to close the dropdown when opening the modal
                            }}
                            className="w-full h-8 bg-green-400 mt-2 hover:bg-green-600 focus:bg-green-600 rounded text-white  flex justify-center items-center"
                          >
                            Cancel
                          </button>
                        </ul>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-right">
                      <Link to={`/dashboardTwo/AdminLeadsDetails/${job._id}`}>
                        <button class="font-medium text-blue-600 dark:text-blue-500 hover:underline">
                          View
                        </button>
                      </Link>
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
            <div className="flex justify-center items-start ">
              <div className="flex justify-between my-5 w-[300px]">
                <button onClick={handlePreviousPage} disabled={page === 1}>
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsLTEuMjI0NjQ2Nzk5MTQ3MzUzMmUtMTYsMS4yMjQ2NDY3OTkxNDczNTMyZS0xNiwtMSw1MTIsNTEyKSI+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
                <span className="text-lg font-roboto">
                  Page {page} of {totalPages}
                </span>
                <button onClick={handleNextPage} disabled={page === totalPages}>
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllLeadsGreen;
